<template>
  <div class="hero">
    <div class="login-page-hero" :style="`background-image: url(${authBgFile});`"></div>
    <div class="image-group">
      <img class="opendock-logo" :src="$logoPath" />
    </div>
    <div class="auth-page-tag">
      {{ $t('auth.pages.login.branding.dockSchedulingSoftwareForWarehouses') }}
    </div>
  </div>
</template>

<script>
import authBg from '@/../public/images/auth_bg.png';
export default {
  computed: {
    authBgFile() {
      return authBg;
    }
  }
};
</script>
